window.countryIconFormatter = function(value) {
    if (value) {
        return '<span class="fi fi-'+value+'"></i>';
    }
    return '';
};
